/* eslint-disable no-console */
// eslint-disable-next-line import/no-named-default
import { default as NextImage } from 'next/image';
import PropTypes from 'prop-types';

const LoaderCDN = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
};

const Image = (props) => {
    // eslint-disable-next-line react/prop-types
    if (!props.src) {
        console.error(`Image component requires src prop ${JSON.stringify(props, null, 2)}`);
        return null;
    }

    return (
        <NextImage
            loader={LoaderCDN}
            {...props}
        />
    );
};

Image.propTypes = {
    props: PropTypes.object
};

export default Image;
